import fly from './fly'
import { getAuth } from '@/util/storage'
const auth = getAuth()

//购物车商品列表
export const changeBedListApi = () =>
  fly.get('/base/user/changeBedList.json', { auth })
